<div class="alert-container">
  <mat-icon
    class="icon-buttons icon-with-text trash"
    svgIcon="trash"></mat-icon>
  <span>Заявка № {{ data.proposalNumber }} перенесена в архив</span>
</div>
